import { Box, Typography, TextField, InputAdornment, IconButton, Button } from '@mui/material';
import React, { useState } from 'react';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { lg: '585px', xl: '585px' },
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  height: { lg: '450px', xl: '450px' },
  borderRadius: '9px',
};

const CreatePostModal = (props: any) => {
  const { handleClose } = props;
  const [fileName, setFileName] = useState<string | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setFileName(event.target.files[0].name);
    }
  };
  return (
    <Box sx={style} className="scrollbar-cusgray">
      <Typography sx={{ fontSize: '15px', fontWeight: '500' }}>Create new post</Typography>
      <Box sx={{ backgroundColor: '#EAEFFF', borderRadius: '6px', padding: '20px', mt: 2 }}>
        <Box display={'flex'} justifyContent={'center'}>
          <TextField
            variant="outlined"
            value={fileName || ''}
            placeholder="Choose a cover photo"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <IconButton component="label">
                    <FileUploadOutlinedIcon style={{ fontSize: '18px' }} />
                    <input type="file" hidden onChange={handleFileChange} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            size="small"
            fullWidth
            sx={{
              backgroundColor: '#FFFFFF',
              height: '36px',
              width: '190px',
              '& .MuiOutlinedInput-root': {
                height: '100%',
              },
              '& .MuiInputBase-input': {
                height: '100%',
              },
              '& ::placeholder': {
                fontSize: '12px',
              },
            }}
          />
        </Box>
        <Typography sx={{ fontSize: '10.5px', fontWeight: 400, textAlign: 'center', mt: 2 }}>Max image size: 1 MB | Min width: 1028px | Image format: PNG, JPEG</Typography>
      </Box>
      <Typography sx={{ fontSize: '12px', fontWeight: 500, mt: 2 }}>What do you want to talk about?</Typography>
      <TextField
        label="Type your thoughts..."
        variant="outlined"
        multiline
        rows={3}
        fullWidth
        sx={{
          borderRadius: '6px',
          width: '100%',
          mt: 2,
          '& .MuiOutlinedInput-root': {
            '& textarea': {
              fontSize: '12px',
            },
          },
        }}
        InputLabelProps={{
          sx: {
            fontSize: '12px',
          },
        }}
      />
      <Typography sx={{ fontSize: '12px', fontWeight: 500, mt: 2 }}>Tags</Typography>
      <TextField
        label="Label"
        variant="outlined"
        fullWidth
        sx={{
          borderRadius: '6px',
          width: '100%',
          mt: 2,
          '& .MuiOutlinedInput-root': {
            height: '45px',
            borderRadius: '6px',
          },
        }}
        InputLabelProps={{
          sx: {
            fontSize: '12px',
            marginTop: '0.5px',
          },
        }}
      />
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end', mt: 3 }}>
        <Button variant="text" sx={{ color: '#373A45', fontSize: '12px', fontWeight: 500, backgroundColor: 'white' }} onClick={handleClose}>
          Discard
        </Button>
        <Button
          variant="contained"
          sx={{ backgroundColor: '#30C1FF', height: '36px', borderRadius: '6px', fontSize: '12px', fontWeight: 500, color: 'white', width: '90px', ml: 2 }}
          onClick={handleClose}
        >
          Post
        </Button>
      </Box>
    </Box>
  );
};

export default CreatePostModal;
